import $ from "jquery";
import Sticky from "sticky-js";

export default function () {
    $("[data-sticky-fixed-content]").each(function () {
        let $stickyLock = $(this).closest(".sticky-lock");
        if ($stickyLock.length === 0) return;

        let $stickyElement = $(".sticky-js", $stickyLock);
        if ($stickyElement.length === 0) return;

        let $stickyFixedContent = $(".sticky-fixed-content", $stickyLock);
        if ($stickyFixedContent.length === 0) return;

        $($stickyFixedContent).html($(this));

        $stickyElement.removeClass("sticky-disabled");

        initStickyElement($stickyElement);
    });

    $(".sticky-js").each(function () {
        initStickyElement($(this));
    });

    $(document).ready(function () {
        // Search for the element with class .sticky-footer
        var $stickyFooter = $(".sticky-content");

        // Check if the element is present
        if ($stickyFooter.length > 0) {
            function setFooterOpacity() {
                // Get the height of the window

                //var windowHeight = $(window).height();

                var opacityTriggerPoint = $(".footer-top-content").offset().top;
                //var totalHeight = $(document).height() - fullOpacityPoint;
                var topOfStickyFooter = $stickyFooter.offset().top;

                // Get the distance from the bottom of the container to the bottom of the window
                //var distanceFromBottom = totalHeight - ($stickyFooter.offset().top + windowHeight);

                // Display the distance in pixels
                /*console.log(
                    "Distance from change point: " + distanceFromBottom
                );
                console.log("window Point: " + windowHeight);*/

                /*var opacity =
                    distanceFromBottom > windowHeight
                        ? 0
                        : distanceFromBottom < windowHeight
                        ? 1
                        : 1;
                console.log(opacity);*/

                //var setOpacity = Math.min(1, Math.max(0.0, opacity)).toFixed(1);
                if (topOfStickyFooter < opacityTriggerPoint) {
                    $stickyFooter.addClass("opacity-0");
                    $stickyFooter.removeClass("opacity-100");
                } else {
                    $stickyFooter.addClass("opacity-100");
                    $stickyFooter.removeClass("opacity-0");
                }

                //stickyFooter.css("opacity", setOpacity);
            }

            // Track the scroll event
            $(window).on("scroll resize orientationchange", function () {
                setFooterOpacity();
            });
        }
    });

    function initStickyElement($stickyElement) {
        let stickyId = $stickyElement.data("sticky-id");

        if ($(`[data-sticky-id="${stickyId}"]`).data("sticky")) {
            $(`[data-sticky-id="${stickyId}"]`).data("sticky").update();
            return;
        }

        let stickyClasses = $(`[data-sticky-id="${stickyId}"]`).data(
            "sticky-class",
        );
        stickyClasses = stickyClasses.replace(/(\r\n|\n|\r)/gm, "");
        stickyClasses = stickyClasses.replace(/\s+/g, " ");

        let sticky = new Sticky(`[data-sticky-id="${stickyId}"]`, {
            beforeSetPosition: function (element, stickyInstance) {
                if ($(element).hasClass("sticky-disabled")) {
                    $stickyElement.removeData("sticky-status");

                    return false;
                }
            },
            afterSetPosition: function (element, stickyInstance) {
                if (
                    typeof window[
                        $(element).data("sticky-after-set-position-callback")
                    ] === "function"
                ) {
                    window[
                        $(element).data("sticky-after-set-position-callback")
                    ](element, stickyInstance);
                }

                let newStickyStatus = $(element).hasClass("is-sticky");

                if ($stickyElement.data("sticky-status") === newStickyStatus)
                    return;

                $stickyElement.data("sticky-status", newStickyStatus);

                //console.log(newStickyStatus);

                let $stickyAffected = $(`[data-sticky-affected=${stickyId}]`);
                $stickyAffected.each(function () {
                    let stickyActiveClasses =
                        $(this).data("on-sticky-class") || "";
                    let stickyActiveRemoveClasses =
                        $(this).data("on-sticky-remove-class") || "";
                    let stickyInActiveClasses =
                        $(this).data("on-sticky-inactive-class") || "";
                    let stickyInActiveRemoveClasses =
                        $(this).data("on-sticky-inactive-remove-class") || "";

                    if ($stickyElement.data("sticky-status")) {
                        $(this).removeClass(stickyActiveRemoveClasses);
                        $(this).addClass(stickyActiveClasses);
                    } else {
                        $(this).removeClass(stickyInActiveRemoveClasses);
                        $(this).addClass(stickyInActiveClasses);
                    }
                });
            },
        });

        $stickyElement.attr("data-sticky-init", "");
        $stickyElement.addClass("sticky-initialized", "");
        $stickyElement.data("sticky", sticky);
    }
}
